"use client";
import { useState } from "react";
// import { Skeleton } from "@mui/material";
import Categories from "./categories";
import FinishBooking from "./finishBooking";
import LandingHeader from "./header";
// import { useHasPendingBookings } from "@/hooks/useHasPendingBookings";

const GlobalHeader: React.FC = () => {
  const [open, setOpen] = useState<boolean>(false);

  // const { isLoading } = useHasPendingBookings();

  // if (isLoading) {
  //   return <Skeleton variant="rounded" height={1100}></Skeleton>;
  // }

  return (
    <>
      <LandingHeader open={open} setOpen={setOpen} />
      <FinishBooking />
      <Categories setOpen={setOpen} />
    </>
  );
};

export default GlobalHeader;
